<template>
  <div>
    <b-alert
      variant="success"
      :show="showAlert_success"
      @dismissed="showAlert_success = false"
      >{{ alert_success_message }}</b-alert
    >
    <b-container fluid>
      <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items" />

      <b-card class="mb-1">
        <b-row class="mb-2">
          <b-col class="col-2">
            <strong>Invoice#</strong>
          </b-col>
          <b-col>
            <b-form-input
              size="sm"
              type="text"
              placeholder
              v-model="inbound_shipment.invoice_no"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col class="col-2">
            <strong>Shipment Type</strong>
          </b-col>
          <b-col>
            <b-form-input
              size="sm"
              type="text"
              placeholder
              v-model="inbound_shipment.shipment_type"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col class="col-2">
            <strong>Invoice Date</strong>
          </b-col>
          <b-col
            ><b-form-input
              size="sm"
              type="date"
              placeholder
              v-model="inbound_shipment.invoice_date"
            ></b-form-input
          ></b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col class="col-2">
            <strong>ETA</strong>
          </b-col>
          <b-col
            ><b-form-input
              size="sm"
              type="date"
              placeholder
              v-model="inbound_shipment.eta"
            ></b-form-input
          ></b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col class="col-2">
            <strong>Supplier</strong>
          </b-col>
          <b-col>
            <b-form-select
              v-model="inbound_shippment.supplier_id"
              @change="onChangeSupplier"
              size="sm"
              :options="supplier_options"
            />
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col class="col-2">
            <strong>Remark</strong>
          </b-col>
          <b-col
            ><b-form-input
              size="sm"
              type="text"
              placeholder
              v-model="inbound_shipment.remark"
            ></b-form-input
          ></b-col>
        </b-row>
      </b-card>

      <h4
        class="mt-3"
        v-if="
          $store.state.user_obj.account_type == 'admin' ||
            $store.state.user_obj.account_type == 'cs' ||
            $store.state.user_obj.account_type == 'young_living'
        "
      >
        Products
      </h4>

      <b-card>
        <div class="mb-3">
          <b-row>
            <b-col class="">
              <b-button
                class="btn-action"
                size="sm"
                variant="info"
                @click="updateProductsStatus('confirmed')"
                v-if="
                  $store.state.user_obj.account_type == 'admin' ||
                    $store.state.user_obj.account_type == 'logistic'
                "
                >Mark as Confirmed</b-button
              >

              <b-button
                class="btn-action"
                size="sm"
                variant="info"
                @click="updateProductsStatus('attention')"
                v-if="
                  $store.state.user_obj.account_type == 'admin' ||
                    $store.state.user_obj.account_type == 'logistic'
                "
                >Mark as "Attention Required"</b-button
              >

              <!-- <b-button
                class="btn-action"
                size="sm"
                variant="info"
                @click="addProductRow"
                >Add Product Row</b-button
              > -->
            </b-col>
          </b-row>
        </div>
        <b-table
          responsive
          small
          outlined
          striped
          hover
          :items="product_items"
          :fields="product_fields"
        >
          <template v-slot:head(chk_box)="data">
            <b-form-checkbox
              size="sm"
              plain
              id="chkbox_all"
              value="all"
              v-model="check_all_products"
            ></b-form-checkbox>
          </template>
          <template v-slot:cell(chk_box)="data">
            <b-form-checkbox
              size="sm"
              class="chkbox_row"
              plain
              :id="'chkbox_row_' + data.index"
              v-model="data.item.is_checked"
            ></b-form-checkbox>
          </template>
          <template v-slot:cell(product_name)="data">
            <!-- <b-form-input
              size="sm"
              type="text"
              required
              placeholder
              v-model="data.item.item_number"
            ></b-form-input> -->
            <!-- <b-form-select
              v-model="data.item.item_number"
              size="sm"
              :options="product_options"
            /> -->
            {{ data.item.product_name }}
          </template>

          <template v-slot:cell(variant)="data">
            <!-- <b-form-input
              size="sm"
              type="text"
              required
              placeholder
              v-model="data.item.item_description"
            ></b-form-input> -->
            <!-- <b-form-select
              v-model="data.item.item_description"
              size="sm"
              :options="variant_options"
            /> -->
            /
          </template>

          <template v-slot:cell(quantity)="data">
            <b-row no-gutters>
              <b-col>
                <b-form-input
                  size="sm"
                  type="text"
                  required
                  placeholder
                  v-model="data.item.quantity"
                  class="mb-1"
                ></b-form-input>
              </b-col>
              <!-- <b-col md="auto">
                <b-button
                  size="sm"
                  class="btn-action"
                  variant="info"
                  @click="addQtyRow(data.item, data.index)"
                  >Add Row</b-button
                >
              </b-col> -->
            </b-row>

            <b-row
              no-gutters
              :key="qty_group_i"
              v-for="(qty_group, qty_group_i) in data.item.qty_groups"
            >
              <b-col>
                <b-form-input
                  type="text"
                  required
                  size="sm"
                  placeholder="Quantity"
                  v-model="qty_group.quantity"
                ></b-form-input>
              </b-col>
              <b-col>
                <!-- <b-form-input
                  type="text"
                  required
                  placeholder="Type"
                  v-model="qty_group.inventory_type"
                ></b-form-input> -->
                <b-form-select
                  size="sm"
                  v-model="qty_group.inventory_type"
                  :options="inventory_type_options"
                />
              </b-col>
              <b-col>
                <!-- <b-form-input
                  type="text"
                  required
                  size="sm"
                  placeholder="Location"
                  v-model="qty_group.location"
                ></b-form-input> -->
                <b-form-select
                  size="sm"
                  v-model="qty_group.location"
                  :options="location_options"
                />
              </b-col>
            </b-row>
          </template>

          <template v-slot:cell(remark)="data">
            <b-form-input
              size="sm"
              type="text"
              required
              placeholder
              v-model="data.item.remark"
            ></b-form-input>
          </template>

          <template v-slot:cell(os_qty)="data">
            0
          </template>

          <template v-slot:cell(status)="data">
            <b-form-input
              class="txt_camelcase"
              size="sm"
              type="text"
              required
              placeholder
              v-model="data.item.item_status"
              disabled
            ></b-form-input>
          </template>
        </b-table>
      </b-card>

      <b-button
        style="float: right;"
        class="btn-action mt-2"
        size="sm"
        variant="info"
        @click="createInboundShipment"
        >Save</b-button
      >

      <!-- <h4 class="mt-3">Change Log</h4>
      <b-card>
        <b-table
          responsive
          small
          outlined
          striped
          hover
          :items="cl_items"
          :fields="cl_fields"
        >
          <template slot="status" slot-scope="data">{{
            data.item.status
          }}</template>

          <template slot="changes" slot-scope="data">
            <div
              style="max-width: 200px; white-space: pre-line; word-break: break-word;"
            >
              {{ data.item.from_val }} -> {{ data.item.to_val }}
              <div v-if="data.item.other_reason">
                [{{ data.item.other_reason }}]
              </div>
              <div
                v-if="
                  data.item.reschedule_date &&
                    data.item.reschedule_date != '0000-00-00 00:00:00'
                "
              >
                [{{ data.item.reschedule_date }}]
              </div>
            </div>
          </template>

          <template slot="remark" slot-scope="data">
            <div
              style="max-width: 200px; white-space: pre-line; word-break: break-word;"
            >
              {{ data.item.remark }}
            </div>
          </template>

          <template slot="updated_at" slot-scope="data">
            <div v-if="data.item.updated_by != ''">
              {{ data.item.updated_at }}
            </div>
          </template>

          <template slot="action" slot-scope="data">
            <b-button
              v-if="
                ($store.state.user_obj.account_type == 'admin' ||
                  $store.state.user_obj.account_type == 'cs') &&
                  data.item.status == 'pending'
              "
              class="btn-action"
              size="sm"
              variant="success"
              @click.stop="executeCR(data.item)"
              >Execute</b-button
            >

            <b-button
              v-if="data.item.status == 'pending'"
              class="btn-action"
              size="sm"
              variant="danger"
              @click.stop="cancelCR(data.item)"
              >Cancel</b-button
            >
          </template>
        </b-table>
      </b-card> -->
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const fields = [
  {
    key: "order_id",
    label: "Order#"
  },
  {
    key: "barcode",
    label: "Barcode"
  },
  {
    key: "attention",
    label: "Attention"
  },
  {
    key: "phone",
    label: "Phone"
  },
  {
    key: "status",
    label: "Status"
  },
  {
    key: "schedule_date",
    label: "Scheduled Date"
  },
  {
    key: "pod_image",
    label: "POD Record"
  },
  {
    key: "carried_by",
    label: "Carried by"
  },
  {
    key: "updated_at",
    label: "Last Updated"
  }
];

import CsIssue_Card from "../components/CsIssue_Card.vue";

export default {
  name: "InboundShipment",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  components: {
    barcode: VueBarcode,
    "cs-issue-card": CsIssue_Card
  },
  data() {
    return {
      new_doc_record: {},
      updating_item: false,
      breadcrumb_items: [
        {
          text: "Inbound Shipment",
          to: { name: "inbound_shipments" }
        },
        {
          text: "Detail",
          active: true
        }
      ],
      document_items: [],
      document_fields: [
        {
          key: "document_name",
          label: "Document Name"
        },
        {
          key: "created_by",
          label: "Uploaded By"
        },
        {
          key: "created_at",
          label: "Uploaded at"
        }
      ],

      product_items: [],
      product_fields: [
        {
          key: "product_sku",
          label: "Product"
        },
        {
          key: "os_qty",
          label: "Outstanding Qty",
          class: "center_align"
        },
        {
          key: "quantity",
          label: "Quantity"
        },
        {
          key: "remark",
          label: "Remark"
        }
      ],
      loader: false,
      items: [{ id: false }],
      inbound_shipment: {
        id: false,
        invoice_date: moment().format("YYYY-MM-DD"),
        eta: moment().format("YYYY-MM-DD")
      },
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      manual_return_order_id: "",
      updating_item: false,
      search_criteria: {
        keyword: "",
        status_selected: null
      },
      inventory_type_options: [
        {
          value: "Active",
          text: "Active"
        },
        {
          value: "Damaged",
          text: "Damaged"
        },
        {
          value: "Hold",
          text: "Hold"
        },
        {
          value: "Expired",
          text: "Expired"
        },
        {
          value: "Committed",
          text: "Committed"
        }
      ],
      status_options: [
        {
          value: null,
          text: "All Status"
        },
        {
          value: "Pending",
          text: "Pending"
        },
        {
          value: "In-Transit",
          text: "In-Transit"
        },
        {
          value: "Returning to GOLS Warehouse",
          text: "Returning to GOLS Warehouse"
        },
        {
          value: "Successful Delivery",
          text: "Successful Delivery"
        },
        {
          value: "Returned to Warehouse",
          text: "Returned to Warehouse"
        }
      ],
      reschedule_type_selected: "before",
      reschedule_type_options: [
        {
          value: "before",
          text: "before"
        },
        {
          value: "on",
          text: "on"
        },
        {
          value: "after",
          text: "after"
        }
      ],
      reschedule_date: moment().format("YYYY-MM-DD"),
      showAlert_success: false,
      alert_success_message: "",
      document_file: [],
      file_document: false,
      location_options: [],
      check_all_products: false,

      product_options: [
        {
          text: "A1000010-Lifetrons Ion Eye Massager Travel Set",
          value: "A1000010-Lifetrons Ion Eye Massager Travel Set"
        },
        {
          text: "N1000010-Soothe N Glow Seahorse",
          value: "N1000010-Soothe N Glow Seahorse"
        }
      ],

      variant_options: [
        {
          text: "small-blue",
          value: "small-blue"
        },
        {
          text: "small-red",
          value: "small-red"
        }
      ],
      supplier_options: [
        {
          text: "supplier 1",
          value: "supplier 1"
        },
        {
          text: "supplier 2",
          value: "supplier 2"
        }
      ],

      products: [],
      inbound_shippment: {}
    };
  },
  async created() {
    // await this.getInbound_Shipment();
    // await this.getInbound_Shipment_Products();
    // await this.getInbound_Shipment_Docs();
    await this.getProductMaster();
    await this.getFookleiSuppliers();
    this.initialized = true;
  },
  mounted() {
    // this.loader = this.$loading.show({
    //   isFullPage: true,
    //   canCancel: false
    // });
  },
  watch: {
    // whenever changes, this function will run
    check_all_products: function(new_val, old_val) {
      // this.check_all_products = !this.check_all_products;
      console.log("check_all_products");
      if (new_val == "all") {
        // Check all
        for (let i in this.product_items) {
          this.product_items[i].is_checked = true;
        }
      } else {
        for (let i in this.product_items) {
          this.product_items[i].is_checked = false;
        }
      }
      console.log(this.product_items);
    }
  },
  methods: {
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getFookleiSuppliers() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "fooklei_supplier_get.php",
        data: {
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id
        }
      });

      this.supplier_options = [];
      for (let i in response.data.suppliers) {
        this.supplier_options.push({
          text: response.data.suppliers[i].name,
          value: response.data.suppliers[i].id
        });
      }
    },

    async getInbound_Shipment() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_get.php",
        data: {
          inbound_shipment_id: this.$route.params.inbound_shipment_id,
          account_type: this.$store.state.user_obj.account_type
        }
      });
      this.inbound_shipment = response.data.inbound_shipments[0];
      this.items.push(this.inbound_shipment);

      this.loader.hide();
    },

    async getInbound_Shipment_Products() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_product_get.php",
        data: {
          inbound_shipment_id: this.$route.params.inbound_shipment_id,
          account_type: this.$store.state.user_obj.account_type
        }
      });
      for (let i in response.data.inbound_shipment_products) {
        if (
          !response.data.inbound_shipment_products[i].qty_groups ||
          response.data.inbound_shipment_products[i].qty_groups.length == 0
        ) {
          response.data.inbound_shipment_products[i].qty_groups = [
            {
              quantity: response.data.inbound_shipment_products[i].qty,
              inventory_type: "Active",
              location: ""
            }
          ];
        }
      }
      this.product_items = response.data.inbound_shipment_products;

      this.loader.hide();
    },

    async getInbound_Shipment_Docs() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_doc_get.php",
        data: {
          inbound_shipment_id: this.$route.params.inbound_shipment_id,
          account_type: this.$store.state.user_obj.account_type
        }
      });
      this.document_items = response.data.inbound_shipment_docs;

      this.loader.hide();
    },

    async updateProductsInfo() {
      let params = {
        inbound_shipment_id: this.$route.params.inbound_shipment_id,
        account_type: this.$store.state.user_obj.account_type,
        product_items: this.product_items,
        user_id: this.$store.state.user_obj.user_id
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_update_product_info.php",
        data: params
      });

      this.getInbound_Shipment_Products();
    },

    async updateProductsStatus(status) {
      let params = {
        inbound_shipment_id: this.$route.params.inbound_shipment_id,
        account_type: this.$store.state.user_obj.account_type,
        product_items: this.product_items,
        user_id: this.$store.state.user_obj.user_id,
        status: status
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_update_product_status.php",
        data: params
      });

      this.getInbound_Shipment_Products();
    },

    async createInboundShipment() {
      let params = {
        inbound_shipment: this.inbound_shipment,
        product_items: this.product_items,
        account_type: this.$store.state.user_obj.account_type,
        user_id: this.$store.state.user_obj.user_id,
        client_id: this.$store.state.user_obj.client_id,
        status: "received"
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_add.php",
        data: params
      });

      // this.getInbound_Shipment();
      this.$router.go(-1);
    },

    async getProductMaster() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "fooklei_product_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: {},
          client_id: this.$store.state.user_obj.client_id
        }
      });
      this.products = response.data.products;
    },

    onChangeSupplier() {
      console.log("onChangeSupplier");
      this.getProductsBySupplier();
    },

    async getProductsBySupplier() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "product_master_get.php",
        data: {
          supplier_id: this.inbound_shippment.supplier_id,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id
        }
      });

      this.product_options = [];
      this.product_items = [];
      for (let i in response.data.products) {
        let tmp_product = response.data.products[i];
        this.product_options.push({
          text: tmp_product.name,
          value: tmp_product.id
        });

        this.product_items.push({
          product_id: tmp_product.id,
          product_name: tmp_product.product_sku,
          product_sku: tmp_product.product_sku,
          quantity: 0,
          remark: ""
        });
      }
    }
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.file_document {
  display: none;
}

.preview_img-product {
  max-width: 100%;
  max-height: 200px;
}

.container-preview_img {
  padding: 5px;
}

.icon-add_image {
  color: #cacaca;
}
</style>



// WEBPACK FOOTER //
// src/components/InboundShipmentCreate.vue